export default "__VITE_ASSET__B$6O83nz__"